import { Box, Typography } from '@mui/material';
import { Error as ErrorIllustration } from '@opengov/react-capital-assets';
import React from 'react';

import { styles } from './common-styles';

export const ErrorResults = ({
  title = 'Search is currently unavailable',
  description = 'We apologize for any inconvenience. We are working very hard to fix the issue.'
}: {
  title?: string;
  description?: string;
}) => {
  return (
    <Box sx={styles.searchEmpty}>
      <ErrorIllustration role="presentation" height="160px" />
      <Typography variant="bodyLarge" mt={3}>
        {title}
      </Typography>
      <Typography variant="bodySmall" color="secondary.main" mb={2}>
        {description}
      </Typography>
    </Box>
  );
};
